module.exports = __webpack_public_path__ + "static/media/hearts_Q.d9191fa9.png";